const backToTop = document.getElementById('back-to-top');

window.addEventListener('scroll', () => {
  backToTop.classList.toggle('visible', window.scrollY > 400);
}, { passive: true });

backToTop.addEventListener('click', () => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
});

const sidebarToggle = document.getElementById('sidebar-toggle');
const sidebarNav = document.getElementById('sidebar-nav');

if (sidebarToggle && sidebarNav) {
  sidebarToggle.addEventListener('click', () => {
    const open = sidebarNav.classList.toggle('open');
    sidebarToggle.setAttribute('aria-expanded', open);
  });

  sidebarNav.querySelectorAll('.cat-btn').forEach(button => {
    button.addEventListener('click', () => {
      if (window.innerWidth <= 980) {
        sidebarNav.classList.remove('open');
        sidebarToggle.setAttribute('aria-expanded', 'false');
      }
    });
  });
}

const categoryButtons = document.querySelectorAll('.cat-btn');
const productCards = document.querySelectorAll('.product-card');
const sectionBreaks = document.querySelectorAll('.grid-section-break');
const sectionLabel = document.getElementById('section-label');
const itemCount = document.getElementById('item-count');
const categoryNames = {
  all: 'All Items',
  buynow: 'Buy Now',
  preorder: 'Pre-Order',
  apparel: 'Apparel',
  accessories: 'Accessories',
  prints: 'Art Prints',
  plushies: 'Plushies',
  bundles: 'Bundles',
  digital: 'Digital',
};

categoryButtons.forEach(button => {
  button.addEventListener('click', () => {
    categoryButtons.forEach(categoryButton => categoryButton.classList.remove('active'));
    button.classList.add('active');

    const category = button.dataset.category;
    let visibleCount = 0;

    productCards.forEach(card => {
      const categories = (card.dataset.category || '').split(/\s+/).filter(Boolean);
      let visible = categories.includes(category);
      if (category === 'all') visible = true;
      if (category === 'buynow') visible = !categories.includes('preorder');
      card.classList.toggle('hidden', !visible);
      if (visible) visibleCount += 1;
    });

    sectionBreaks.forEach(sectionBreak => {
      const section = sectionBreak.dataset.section;
      const visible = category === 'all' || category === section;
      sectionBreak.style.display = visible ? '' : 'none';
    });

    sectionLabel.textContent = categoryNames[category] || category;
    itemCount.textContent = `${visibleCount} item${visibleCount === 1 ? '' : 's'}`;
  });
});

const conversationData = document.getElementById('conversations-data');

if (conversationData) {
  try {
    const conversations = JSON.parse(conversationData.textContent);
    if (conversations.length > 0) {
      const conversation = conversations[Math.floor(Math.random() * conversations.length)];
      const speechA = document.getElementById('speech-a');
      const speechB = document.getElementById('speech-b');
      if (speechA) speechA.textContent = conversation[0];
      if (speechB) speechB.textContent = conversation[1];
    }
  } catch (error) {
    console.error('Store conversation data could not be read.', error);
  }
}

const audio = document.getElementById('shop-audio');
const playButton = document.getElementById('music-play-btn');
const musicControls = document.getElementById('music-controls');
const stopButton = document.getElementById('music-toggle');
const volumeSlider = document.getElementById('music-slider');

if (audio && playButton && musicControls && stopButton && volumeSlider) {
  function updateSliderFill() {
    volumeSlider.style.setProperty('--val', `${volumeSlider.value}%`);
  }

  function setAudioUnavailable() {
    audio.pause();
    musicControls.classList.remove('visible');
    musicControls.style.width = '';
    playButton.style.display = '';
    playButton.textContent = 'Audio unavailable';
    playButton.disabled = true;
  }

  audio.volume = 0.2;
  updateSliderFill();
  audio.addEventListener('error', setAudioUnavailable);
  if (audio.error) setAudioUnavailable();

  playButton.addEventListener('click', async () => {
    const buttonWidth = playButton.getBoundingClientRect().width;
    musicControls.style.width = `${buttonWidth}px`;

    try {
      await audio.play();
      playButton.style.display = 'none';
      musicControls.classList.add('visible');
    } catch (error) {
      console.error('Store audio could not be played.', error);
      setAudioUnavailable();
    }
  });

  stopButton.addEventListener('click', () => {
    audio.pause();
    audio.currentTime = 0;
    musicControls.classList.remove('visible');
    musicControls.style.width = '';
    playButton.style.display = '';
  });

  volumeSlider.addEventListener('input', () => {
    audio.volume = volumeSlider.value / 100;
    updateSliderFill();
  });
}

const userAgent = navigator.userAgent.toLowerCase();
if (userAgent.includes('firefox') || userAgent.includes('opr/')) {
  document.body.classList.add('perf-mode');
}

document.querySelectorAll('.grid-section-break').forEach(sectionBreak => {
  if (sectionBreak.querySelector('.gsb-preorder')) sectionBreak.classList.add('is-preorder');
});

function useLogoFallback(logo) {
  const fallback = logo.dataset.fallbackSrc;
  if (fallback && logo.src !== fallback) logo.src = fallback;
}

document.querySelectorAll('.header-logo[data-fallback-src]').forEach(logo => {
  logo.addEventListener('error', () => useLogoFallback(logo), { once: true });
  if (logo.complete && logo.naturalWidth === 0) useLogoFallback(logo);
});

document.querySelectorAll('img').forEach(image => {
  image.addEventListener('contextmenu', event => event.preventDefault());
  image.style.webkitUserDrag = 'none';
  image.style.MozUserDrag = 'none';
  image.style.userDrag = 'none';
  image.setAttribute('draggable', 'false');
  image.style.webkitUserSelect = 'none';
  image.style.MozUserSelect = 'none';
  image.style.msUserSelect = 'none';
  image.style.userSelect = 'none';
});
